import * as React from 'react';
const Archive = (props) => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", className: "feather feather-archive", ...props },
    React.createElement("polyline", { points: "21 8 21 21 3 21 3 8" }),
    React.createElement("rect", { x: "1", y: "3", width: "22", height: "5" }),
    React.createElement("line", { x1: "10", y1: "12", x2: "14", y2: "12" })));
export default Archive;
//# sourceMappingURL=Archive.js.map